// extracted by mini-css-extract-plugin
module.exports = {"NameBox":"NameBox_NameBox__37kVu","Type":"NameBox_Type__16wRK","Value":"NameBox_Value__3fNbK"};